import { alpha, Box, styled } from '@mui/material';

export const VideoPreviewContainer = styled(Box)(({}) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  cursor: 'pointer',
}));

export const StyledVideo = styled('video')({
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

export const VideoPreviewControls = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  background: alpha(theme.palette.common.black, 0.6),
  borderRadius: '50%',
  width: 38,
  height: 38,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none',
}));

export const StopControl = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.h4.fontSize,
  fontWeight: 'bold',
  userSelect: 'none',
}));

export const PlayControl = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.h5.fontSize,
  marginLeft: 2,
  fontWeight: 'bold',
  userSelect: 'none',
}));
